export default __webpack_public_path__ + "static/media/foodle-design03.99ce9531.jpg";